import { currentToken } from "shared/helpers/authorization";
import ActionCableSubscription from "shared/services/ActionCableSubscription";
import { type ActionCableSubscriptionConfig } from "shared/services/ActionCableSubscription";
import type { MentionType } from "shared/types/mentions";

export enum UrlStatus {
  alreadyAdded = "already_added",
  canBeAdded = "can_be_added",
  cannotBeAdded = "cannot_be_added",
}

export enum CannotBeAddedReason {
  duplicatedUrl = "duplicated_url",
  invalidUrl = "invalid_url",
  licensing = "licensing",
  socialMediaLink = "social_media_link",
}

export interface UrlVerificationResult {
  mention_id?: number;
  mention_type?: MentionType;
  reason?: CannotBeAddedReason;
  url: string;
  url_status: UrlStatus;
}

export type SubscriptionConfig =
  ActionCableSubscriptionConfig<UrlVerificationResult>;

export type UrlVerifiedHandler = SubscriptionConfig["onUpdate"];

export default function useUrlVerificationNotificationsSubscription() {
  let subscription: ActionCableSubscription<UrlVerificationResult>;

  async function subscribeToNotifications(onUpdate: UrlVerifiedHandler) {
    const token = await currentToken();

    subscription = new ActionCableSubscription({
      channel: "VerifyUrlsForExternalItemsNotificationsChannel",
      onUpdate,
      options: { global: false },
      token,
    } as SubscriptionConfig);

    await subscription.subscribe();
  }

  function unsubscribeFromNotifications() {
    subscription?.unsubscribe();
  }

  return {
    subscribeToNotifications,
    unsubscribeFromNotifications,
  };
}
